import 'css-chunksrc/client/pages/fillAccountPage/styles.scss';export default {
  "fillAccountPage": "_fillAccountPage_mnfnx_1",
  "main": "_main_mnfnx_10",
  "header": "_header_mnfnx_24",
  "title": "_title_mnfnx_29",
  "form": "_form_mnfnx_36"
};